import api from './api'

// ⚠️ ENDPOINT REAL DE BIND - Backend hace proxy
// El backend llama a: GET https://sandbox.bind.com.ar/v1/banks/:bank_id/accounts/:view_id
// Path params: bank_id=322, view_id=owner
export async function getAccounts() {
  const response = await api.get('/accounts')
  return response.data
}

// ⚠️ ENDPOINT REAL DE BIND - Backend hace proxy
// El backend llama a: GET https://sandbox.bind.com.ar/v1/banks/:bank_id/accounts/:account_id/:view_id/transactions
// Path params: bank_id=322, account_id=XX-X-XXXX-X-X, view_id=owner
// Query params: obp_from_date, obp_to_date, obp_limit, obp_offset, obp_sort_direction, obp_categories
// BIND - GET con query params
export async function getTransactions(accountId, params = {}) {
  const queryParams = new URLSearchParams()
  
  if (params.from) queryParams.append('from', params.from)
  if (params.to) queryParams.append('to', params.to)
  if (params.limit) queryParams.append('limit', params.limit)
  if (params.offset) queryParams.append('offset', params.offset)
  if (params.sort) queryParams.append('sort', params.sort)
  if (params.categories) queryParams.append('categories', params.categories)

  const response = await api.get(
    `/accounts/${accountId}/transactions?${queryParams.toString()}`
  )
  return response.data
}

// CREDENCIAL - POST con body JSON
export async function getTransactionsCredencial(params = {}) {
  console.log('🔵 [accountService] getTransactionsCredencial llamado con forceAPI:', params.forceAPI)
  const response = await api.post('/accounts/movements', {
    card: "",
    alias: "",
    account: params.account || "",
    date_from: params.from || params.date_from,
    date_to: params.to || params.date_to,
    page: params.page || 1,
    forceAPI: params.forceAPI || false // NUEVO: Para saltar DB local y consultar directo a Credencial
  })
  return response.data
}

// ⚠️ ENDPOINT DE CREDENCIAL - Consultar saldo
// El backend llama a: POST https://app.cmsargentina.com/api/transactions/v2/getBalanceWithoutMovements
// Body: { account, trace, retrieval }
export async function getBalance(accountNumber) {
  const response = await api.post('/accounts/balance', { accountNumber })
  return response.data
}

// ⚠️ ENDPOINT DE CREDENCIAL - Consultar información de CVU
// El backend llama a: POST https://app.cmsargentina.com/api/coelsa/v2/getCVUInformation
// Body: { cvu }
export async function getCVUInfo(cvu) {
  const response = await api.post('/accounts/cvu-info', { cvu })
  return response.data
}

// EXPORTACIÓN RÁPIDA - Solo para usuarios con DB local
// Devuelve TODOS los movimientos sin paginación (descarga instantánea)
export async function exportMovements(params = {}) {
  console.log('📤 [accountService] exportMovements - Exportación rápida desde DB local')
  const response = await api.post('/accounts/export-movements', {
    account: params.account || "",
    date_from: params.from || params.date_from,
    date_to: params.to || params.date_to
  })
  return response.data
}

// Obtener todas las cuentas/CVUs (para selector de cuentas)
export async function getAllCvus() {
  const response = await api.get('/accounts/all-cvus')
  return response.data
}

